import React/*, { HTMLAttributes }*/ from 'react';
import { Container } from 'react-bootstrap';
// import { Like } from 'react-facebook';
import './Footer.scss';
// import { TwitterShareButton, TwitterFollowButton } from 'react-twitter-embed';

// interface IframeHTMLAttributes<T> extends HTMLAttributes<T> {
//   allow?: string;
//   allowFullScreen?: boolean;
//   allowTransparency?: boolean;
//   frameBorder?: number | string;
//   height?: number | string;
//   marginHeight?: number;
//   marginWidth?: number;
//   name?: string;
//   sandbox?: string;
//   scrolling?: string;
//   seamless?: boolean;
//   src?: string;
//   srcDoc?: string;
//   width?: number | string;
// }

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <Container>
        <div className="footer-social">
          {/* <TwitterShareButton
            url={'https://www.scriptureseveryday.com'}
            options={{ text: 'I\'m reading my scriptures every day. Join me!', via: 'ReadYourSED', hashtags: 'ScripturesEveryDay', size: 'large', placeholder: "Tweet about Scriptures Every Day"}}
          />{" "}<TwitterFollowButton screenName="ReadYourSED" options={{ size: 'large' }} />
          <div className="fb-iframe"><Like href="https://www.facebook.com/scriptureseveryday" width="350" layout="standard" action="like" showFaces={true} share={true} colorScheme="dark" /></div> */}
        </div>
        <p>Come back tomorrow for the next assignment.</p>

        <div className="copyright">
          <p>Website copyright &copy;&nbsp;{currentYear}&nbsp;Sean
                        Fisher. Scriptures Every Day is not affiliated with The Church of Jesus Christ of Latter-day Saints.{" "}
            <a href="privacy">Privacy Policy</a></p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
